import { FC } from 'react';
import { Stack, Typography } from '@mui/material';
import {
  IllustrationChat,
  IllustrationChatCheck,
} from '@vs-online-only-app/ui';

type Props = {
  hasActiveConversations: boolean;
};

const AssociateReadyToChatPlaceholder: FC<Props> = ({
  hasActiveConversations,
}) => (
  <Stack gap={2} alignItems="center">
    {hasActiveConversations ? <IllustrationChat /> : <IllustrationChatCheck />}
    <Stack gap={1}>
      <Typography variant="h6" align="center">
        You're ready to chat!
      </Typography>
      <Typography align="center" variant="body2">
        {hasActiveConversations
          ? 'Select a chat to start messaging.'
          : `You'll get notified when customers want to connect.`}
      </Typography>
    </Stack>
  </Stack>
);

export default AssociateReadyToChatPlaceholder;
